import React, { ReactText } from 'react'

import { useSelector } from 'react-redux'

import { ReportFilterOperation } from '@driftt/api-types'

import { classificationSelector } from 'modules/classifications/selectors'
import { BotStatus, WidgetStatus } from 'modules/filter/types'
import { inboxOptions } from 'modules/inboxes/selectors'
import { activeOrgUsersWithEmailAdressesOptions } from 'modules/org/selectors'
import { teamsOptions } from 'modules/teams/selectors'
import { createGetWorkspaceOptions } from 'modules/workspaces/selectors'
import { ReportPage } from 'types/pages'

import { FilterableEntityType } from './useAvailableFilters'

export interface IFilterableEntity {
  property: { value: FilterableEntityType; label: string }
  availableOperations: ReportFilterOperation[]
  optionList: { label: React.ReactNode; value: ReactText }[]
}

export const useFilterableEntities = (
  reportType: ReportPage
): Record<FilterableEntityType, IFilterableEntity> => {
  return {
    workspace: {
      property: { value: 'workspace', label: 'Workspace' },
      availableOperations: [
        ReportFilterOperation.IN,
        ReportFilterOperation.NOT_IN,
      ],
      optionList: useSelector(createGetWorkspaceOptions(reportType)),
    },
    team: {
      property: { value: 'team', label: 'Team' },
      availableOperations: [
        ReportFilterOperation.IN,
        ...(reportType === ReportPage.RealTime
          ? []
          : [ReportFilterOperation.NOT_IN]),
      ],
      optionList: useSelector(teamsOptions),
    },
    inbox: {
      property: { value: 'inbox', label: 'Inbox' },
      availableOperations: [
        ReportFilterOperation.IN,
        ReportFilterOperation.NOT_IN,
      ],
      optionList: useSelector(inboxOptions),
    },
    teammate: {
      property: { value: 'teammate', label: 'Teammate' },
      availableOperations: [
        ReportFilterOperation.IN,
        ...(reportType === ReportPage.RealTime
          ? []
          : [ReportFilterOperation.NOT_IN]),
      ],
      optionList: useSelector(activeOrgUsersWithEmailAdressesOptions),
    },
    botStatus: {
      property: { value: 'botStatus', label: 'Participant types' },
      availableOperations: [ReportFilterOperation.IN],
      optionList: [
        { value: BotStatus.HUMAN_ONLY, label: 'Teammate only' },
        { value: BotStatus.BOT_ASSISTED, label: 'Bot + teammate' },
        { value: BotStatus.BOT_ONLY, label: 'Bot only' },
      ],
    },
    widgetStatus: {
      property: { value: 'widgetStatus', label: 'Drift Widget status' },
      availableOperations: [ReportFilterOperation.IN],
      optionList: [
        { value: WidgetStatus.ONLINE.toString(), label: 'Drift is online' },
        { value: WidgetStatus.OFFLINE.toString(), label: 'Drift is offline' },
      ],
    },
    classification: {
      property: { value: 'classification', label: 'Lead stage' },
      availableOperations: [ReportFilterOperation.IN],
      optionList: useSelector(classificationSelector),
    },
  }
}
